import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: 'mwp-report-builder-company',
    templateUrl: './report-builder-company.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportBuilderCompanyComponent implements OnInit {

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<number> = new EventEmitter();

    public companyForm: FormGroup;

    private companyIdField: string = 'companyID';

    constructor(
        private formBuilder: FormBuilder,
    ) {
        this.companyForm = this.formBuilder.group({
            companyName: [null, Validators.required],
            [this.companyIdField]: [null, Validators.required],
        });
    }

    ngOnInit(): void {
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public save(): void {
        this.emitSave.emit(this.companyForm.get(this.companyIdField).value);
    }

}